export enum ServicePaymentDropdownHooks {
  dropdown = 'service-payment-dropdown',
}
